// extracted by mini-css-extract-plugin
export var aircallIframe = "_io-3";
export var fabContainer = "_io-5";
export var fabRinging = "_io-6";
export var loadingOverlay = "_io-4";
export var pulse = "_io-7";
export var widgetContent = "_io-2";
export var widgetPanel = "_io-0";
export var widgetPanelExpanded = "_io-1";